/* eslint-disable */
export default {
  currentCall: '当前通话',
  viewCalls: '查看呼叫',
  view: '查看',
  incomingCall: '{numberOf} 个呼入电话',
  incomingCalls: '{numberOf} 个呼入电话',
  callOnHold: '{numberOf} 个呼叫暂候',
  callsOnHold: '{numberOf} 个呼叫暂候',
  otherDeviceCall: '其他设备上有 {numberOf} 个呼叫',
  otherDeviceCalls: '其他设备上有 {numberOf} 个呼叫',
} as const;

// @key: @#@"currentCall"@#@ @source: @#@"Current Call"@#@
// @key: @#@"viewCalls"@#@ @source: @#@"View Calls"@#@
// @key: @#@"view"@#@ @source: @#@"View"@#@
// @key: @#@"incomingCall"@#@ @source: @#@"{numberOf} Incoming Call"@#@
// @key: @#@"incomingCalls"@#@ @source: @#@"{numberOf} Incoming Calls"@#@
// @key: @#@"callOnHold"@#@ @source: @#@"{numberOf} Call On Hold"@#@
// @key: @#@"callsOnHold"@#@ @source: @#@"{numberOf} Calls On Hold"@#@
// @key: @#@"otherDeviceCall"@#@ @source: @#@"{numberOf} Call on other devices"@#@
// @key: @#@"otherDeviceCalls"@#@ @source: @#@"{numberOf} Calls on other devices"@#@
